import firebase from 'firebase/compat/app'
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth'
import 'firebase/compat/database'
import authService from './support/AuthService'
import { Md5 } from 'md5-typescript'
import { Moment } from 'moment'
import LogService, { ToString } from './support/LogService'

class FirebaseService {
  auth () {
    return new Promise(async (resolve, reject) => {
      const credentials = await this.getUserCredentials()
      const auth = getAuth()
      signInWithEmailAndPassword(auth, credentials.email, credentials.pass)
        .then((user) => {
          resolve(user)
        }).catch((error) => {
          const errorCode = error.code
          const errorMessage = error.message
          LogService.error(`errorCode: ${ToString(errorCode)}'. errorMessage: ${ToString(errorMessage)}`)
          reject(error)
        })
    })
  }

  private async getUserCredentials () {
    const domainName = await authService.getDomainName()

    return {
      email: `${domainName}-group-r@blumessaging.com`,
      pass: Md5.init(`${domainName}-group-r@blumessaging.com`).substring(0, 8)
    }
  }

  getUserPositionsRef (domainId: string, userId: number, date: Moment) {
    return firebase.database().ref(`DOMAINS/${domainId}/USERS/${userId}/${this.getFormattedDate(date)}/POSITIONS`)
  }

  getUserLastRecordedPositionRef (domainId: string, userId: number) {
    return firebase.database().ref(`DOMAINS/${domainId}/USERS/${userId}/lastRecordedPosition`)
  }

  getUserInfoRef (domainId: string, userId: number) {
    return firebase.database().ref(`DOMAINS/${domainId}/USERS/${userId}/information`)
  }

  private getFormattedDate (date: Moment) {
    return date.format('YYYY/M/D')
  }
}

export default new FirebaseService()
